// extracted by mini-css-extract-plugin
module.exports = {"SwiperModule":"SwiperModule_SwiperModule__a1TLL"};